<script setup lang="ts">
  import { Text, IconASmall, IconBSmall } from "@ui-kit";
  import { getPlace } from "@src/dictionary";

  const { order_place_from, store, order_place_section, order_place_to } = defineProps<{
    order_place_from: string;
    store?: string;
    order_place_section: string;
    order_place_to: string;
  }>();
</script>

<template>
  <div class="order-route-direction">
    <div class="points">
      <IconASmall style="width: 16px; height: 16px" />
      <IconBSmall :class="`point-color-${order_place_section.toLowerCase()}`" style="width: 16px; height: 16px" />
    </div>
    <div class="route-text">
      <Text>{{ `${getPlace(order_place_from)}${store ? ": " + store : ""}` }}</Text>
      <Text>
        {{ `${order_place_section[0].toUpperCase()}・${getPlace(order_place_to)}` }}
      </Text>
    </div>
  </div>
</template>

<style scoped>
  .order-route-direction {
    display: flex;
    gap: 8px;

    .points {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 2px 0;
      position: relative;
      width: 16px;
      min-height: 36px;
      z-index: 0;

      .point-color-woman :deep(rect) {
        fill: var(--sf-base-icon-error);
      }
      .point-color-man :deep(rect) {
        fill: var(--sf-base-icon-info);
      }
      .point-color-kids :deep(rect) {
        fill: var(--sf-base-icon-success);
      }

      & > * {
        position: relative;
        z-index: 1;
      }

      &::before {
        content: "";
        position: absolute;
        top: 9px;
        bottom: 9px;
        left: 50%;
        border-left: 2px dashed var(--sf-base-background-dark);
        transform: translateX(-50%);
        pointer-events: none;
        z-index: 0;
      }
    }

    .route-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
</style>
